import {FileIcon} from "react-file-icon";
import {clientLog} from "../clientLog";
import {ObjectDefinitions} from "../objectdefinitions/ObjectDefinitions";
import React, {useEffect, useState} from "react";

/**
 * Displays a file icon for a given file, based on its MIME type and extension.
 *
 * @param {string} filename - The filename.
 * @param {string} mimeType - The MIME type of the file.
 * @param {number} size - The size of the icon.
 * @param {boolean} [show=true] - Whether to show the icon.
 *
 * @return {JSX.Element} The rendered file icon component.
 */
export const DamsFileIcon = React.memo(({filename, mimeType, size, show = true}) => {
    const {
        getLabelColor,
        getIconFromFilename,
        getIconFromMimeType,
        getFileExtensionFromFilename,
    } = ObjectDefinitions();

    const radius = 3;

    const [loading, setLoading] = useState(true);
    const [fileType, setFileType] = useState(undefined);
    const [fileExtension, setFileExtension] = useState(undefined);

    useEffect(() => {
        (async () => {
            if (!filename) {
                return;
            }
            let fileExtension = getFileExtensionFromFilename(filename);
            fileExtension = fileExtension === "jpeg" ? "jpg" : fileExtension;
            setFileExtension(fileExtension);

            let icon;
            if (filename.endsWith('.mp4')) {
                icon = await getIconFromMimeType(mimeType);
            } else {
                icon = await getIconFromFilename(filename);
            }

            if (!icon) {
                const msg = `icon type not found for: ${mimeType} ${filename}`;
                clientLog('warn', msg, 'DamsFileIcon');
            }

            setFileType(icon);
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const labelColor = getLabelColor(fileType);

    return <div
        data-testid={"DAMSFileIcon"}
        style={{
            WebkitFontSmoothing: "antialiased",
            width: size + "px",
            minWidth: size + "px",
            zIndex: 999,
        }}>
        {!loading && show && <FileIcon
            size={size}
            type={fileType}
            extension={fileExtension}
            radius={radius}
            key={`${filename}-${size}`}
            labelColor={labelColor}
        />}
        {loading && show && <FileIcon size={size}
                                      key={`dummy-${filename}-${size}`}/>}
    </div>;
});
